import { computed, defineComponent } from 'vue';
import { Check, Close } from '@element-plus/icons-vue';
export default defineComponent({
    props: {
        label: {
            type: String,
            required: true
        },
        modelValue: Boolean,
        placeholder: String,
        description: String,
        disabled: Boolean,
        required: Boolean
    },
    emits: ['update:modelValue', 'change'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        return {
            value,
            Check,
            Close
        };
    }
});
